import { HeaderWrapper, AppBrand } from "./Styles";

const Header = () => {
    return (
        <HeaderWrapper>
            <AppBrand>CV Creator</AppBrand>
        </HeaderWrapper>
    );
};

export default Header;
